import { z } from 'zod';
import { readStoredJson, tolerantArray } from './readStoredJson';

export const IMPERSONATION_QUICK_KEY = 'terra:impersonation:quick';
/** 1–9 pick a chip while the search is empty, so Quick never holds more. */
export const MAX_IMPERSONATION_QUICK = 9;

/** The viewer's pinned Slack ids, or null until they edit Quick (the palette then shows their last three). */
export function readQuickUsers(): string[] | null {
  return readStoredJson(localStorage, IMPERSONATION_QUICK_KEY, tolerantArray(z.string()).nullable(), null);
}

export function saveQuickUsers(slackUserIds: string[]): void {
  try {
    localStorage.setItem(IMPERSONATION_QUICK_KEY, JSON.stringify(slackUserIds.slice(0, MAX_IMPERSONATION_QUICK)));
  } catch {
    // Quick is a per-browser convenience; storage failures leave it unsaved.
  }
}
